/**
 * @file Anything that can run on every page
 */

// import '@elbwalker/walker.js/dist/walker';
// import vHeader from '../components/header/header';
// import vHpHero from '../components/hp-hero/hp-hero';
// import vHpThreeUp from '../components/hp-three-up/hp-three-up';
// import vHpAbout from '../components/hp-about/hp-about';
// import vHpIgFeed from '../components/hp-ig-feed/hp-ig-feed';
// import vHpCarousel from '../components/hp-carousel/hp-carousel';
// import vHpReviews from '../components/hp-reviews/hp-reviews';
// import vImageContentFull from '../components/image-content-full/image-content-full';
// import vImageCtas from '../components/image-ctas/image-ctas';
// import vImageContentOverlay from '../components/image-content-overlay/image-content-overlay';
// import vDetailImageContent from '../components/detail-image-content/detail-image-content';
// import vDetailTriSection from '../components/detail-tri-section/detail-tri-section';
// import vDetailIgGrid from '../components/detail-ig-grid/detail-ig-grid';
// import vProductsHeader from '../components/products-header/products-header';
// import vProductsToolbar from '../components/products-toolbar/products-toolbar';
// import vProductsFilters from '../components/products-filters/products-filters';
// import vProductsGrid from '../components/products-grid/products-grid';
// import vProductDetails from '../components/product-details/product-details';
// import vFaqAccordions from '../components/faq-accordions/faq-accordions';
// import vCartBody from '../components/cart-body/cart-body';
// import vStudioEmbed from '../components/studio-embed/studio-embed';
// import vFavoritesCarousel from '../components/favorites-carousel/favorites-carousel';

/**
 * Global functions
 *
 * Runs component js and any global tasks
 */
const vGlobal = () => {
  import("@elbwalker/walker.js/dist/walker");
  import("../components/header/header").then(({ default: vHeader }) => {
    vHeader();
  });

  // if (document.querySelector('.v-hp-three-up')) {
  // 	import('../components/hp-three-up/hp-three-up').then(({ default: vHpThreeUp }) => { vHpThreeUp(); });
  // }

  if (document.querySelector(".v-newsletter-bar")) {
    import("../components/newsletter-bar/newsletter-bar").then(
      ({ default: vNewsletterBar }) => {
        vNewsletterBar();
      }
    );
  }

  if (document.querySelector(".v-image-content-full")) {
    import("../components/image-content-full/image-content-full").then(
      ({ default: vImageContentFull }) => {
        vImageContentFull();
      }
    );
  }

  if (document.querySelector(".v-image-ctas")) {
    import("../components/image-ctas/image-ctas").then(
      ({ default: vImageCtas }) => {
        vImageCtas();
      }
    );
  }

  if (document.querySelector(".v-image-content-overlay")) {
    import("../components/image-content-overlay/image-content-overlay").then(
      ({ default: vImageContentOverlay }) => {
        vImageContentOverlay();
      }
    );
  }

  if (document.querySelector(".v-detail-image-content")) {
    import("../components/detail-image-content/detail-image-content").then(
      ({ default: vDetailImageContent }) => {
        vDetailImageContent();
      }
    );
  }

  if (document.querySelector(".v-detail-tri-section")) {
    import("../components/detail-tri-section/detail-tri-section").then(
      ({ default: vDetailTriSection }) => {
        vDetailTriSection();
      }
    );
  }

  if (document.querySelector(".v-detail-ig-grid")) {
    import("../components/detail-ig-grid/detail-ig-grid").then(
      ({ default: vDetailIgGrid }) => {
        vDetailIgGrid();
      }
    );
  }

  if (document.querySelector(".v-products-header")) {
    import("../components/products-header/products-header").then(
      ({ default: vProductsHeader }) => {
        vProductsHeader();
      }
    );
  }

  if (document.querySelector(".v-products-toolbar")) {
    import("../components/products-toolbar/products-toolbar").then(
      ({ default: vProductsToolbar }) => {
        vProductsToolbar();
      }
    );
  }

  if (document.querySelector(".v-products-filters")) {
    import("../components/products-filters/products-filters").then(
      ({ default: vProductsFilters }) => {
        vProductsFilters();
      }
    );
  }

  if (document.querySelector(".v-products-grid")) {
    import("../components/products-grid/products-grid").then(
      ({ default: vProductsGrid }) => {
        vProductsGrid();
      }
    );
  }

  if (document.querySelector(".v-product-details")) {
    import("../components/product-details/product-details").then(
      ({ default: vProductDetails }) => {
        vProductDetails();
      }
    );
  }

  if (document.querySelector(".v-faq-accordions")) {
    import("../components/faq-accordions/faq-accordions").then(
      ({ default: vFaqAccordions }) => {
        vFaqAccordions();
      }
    );
  }

  if (document.querySelector(".v-studio-embed")) {
    import("../components/studio-embed/studio-embed").then(
      ({ default: vStudioEmbed }) => {
        vStudioEmbed();
      }
    );
  }

  if (document.querySelector(".v-favorites-carousel")) {
    import("../components/favorites-carousel/favorites-carousel").then(
      ({ default: vFavoritesCarousel }) => {
        vFavoritesCarousel();
      }
    );
  }

  const selects = document.querySelectorAll("select");
  [...selects].forEach((select) => {
    const selectParent = select.parentNode;
    if (selectParent.classList.contains("v-form__select")) {
      return;
    }

    const wrapper = document.createElement("span");
    const arrow = document.createElement("span");
    wrapper.classList.add("v-form__select");
    arrow.classList.add("v-form__select-arrow");
    selectParent.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    wrapper.appendChild(arrow);
    select.classList.add("v-form__select-field");
  });

  const videoObserver = new IntersectionObserver((entries, o) => {
    entries.forEach((video) => {
      if (!video.isIntersecting) {
        return;
      }

      const sources = video.target.querySelectorAll("source");

      [...sources].forEach((source) => {
        if (
          source.parentElement.classList.contains("v-lazy-video--responsive")
        ) {
          const mq = window.matchMedia("(max-width: 768px)");
          const sourceFn = () => {
            source.setAttribute("src", source.getAttribute("data-src"));
          };

          if (mq.matches) {
            window.addEventListener("load", () => {
              sourceFn();

              // load the video
              source.parentElement.load();
            });
          } else {
            sourceFn();
          }
        } else {
          source.setAttribute("src", source.getAttribute("data-src"));
        }
      });

      video.target.load();
      video.target.classList.remove("v-lazy-video");
      o.unobserve(video.target);
    });
  });

  const lazyVideos = document.querySelectorAll(".v-lazy-video");
  [...lazyVideos].forEach((video) => {
    videoObserver.observe(video);
  });

  /**
   * Global Window Load
   *
   * Runs polyfills on page load
   */
  async function onWindowLoad() {
    const body = document.querySelector("body");
    if (!body.classList.contains("admin-bar")) {
      const { listen } = await import(
        /* webpackExports: "listen" */ "quicklink"
      );

      listen({
        ignores: [
          (url) => {
            const cleanUrl = url.replace(/#.*/, "");
            return cleanUrl === window.location.href;
          },
          /.*\/wp-admin\/.*/,
        ],
      });
    }
  }

  if (document.readyState === "complete") {
    onWindowLoad();
  } else {
    window.addEventListener("load", onWindowLoad);
  }
};

if (document.readyState !== "loading") {
  vGlobal();
} else {
  document.addEventListener("DOMContentLoaded", vGlobal);
}
